export default __webpack_public_path__ + "static/media/comment.115b239b.svg";